import { render } from "./ApplicantDetails.vue?vue&type=template&id=4f09c4de&scoped=true"
import script from "./ApplicantDetails.vue?vue&type=script&lang=js"
export * from "./ApplicantDetails.vue?vue&type=script&lang=js"

import "./ApplicantDetails.vue?vue&type=style&index=0&id=4f09c4de&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f09c4de"]])

export default __exports__